import React from 'react';

function RubriqueOption({id, nom,}) {
  return (
    <option value={nom} >{nom}</option>
    )
}

export default RubriqueOption